import styled from 'styled-components'
import { theme } from '../../styles'

export const FooterRoot = styled.footer`
  margin: 46px 0 40px;

  ${theme.mobile} {
    margin: 30px 0 34px;
  }
`

export const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 22px 24px 0;
  border-top: 1px solid ${theme.cores.line};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  color: ${theme.cores.inkFaint};
  font-size: 12.5px;

  ${theme.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
    text-align: left;
    padding: 22px 18px 0;
    justify-content: center;
  }
`

export const FooterLeft = styled.span`
  color: ${theme.cores.inkFaint};
`

export const FooterLinks = styled.div`
  display: flex;
  gap: 22px;
  align-items: center;

  ${theme.mobile} {
    flex-wrap: wrap;
    gap: 14px;
    justify-content: center;
  }
`

export const FooterLink = styled.a`
  color: ${theme.cores.inkSoft};
  text-decoration: none;
  font-size: 12.5px;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.cores.navy};
  }
`

export const LogoutButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${theme.cores.inkSoft};
  font-size: 12.5px;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.cores.navy};
  }
`
